import { createContext, useContext } from 'react';
import { DeviceInfo } from '../types/device';

export interface DeviceDndContextValue {
    draggedDevice: DeviceInfo | null;
    refreshToken: number;
    onDragStart: (device: DeviceInfo) => void;
    onDragEnd: () => void;
    onDrop: (nodeId: number, nodeName: string) => void;
}

export const DeviceDndContext = createContext<DeviceDndContextValue | null>(null);

export function useDeviceDnd(): DeviceDndContextValue | null {
    return useContext(DeviceDndContext);
}
